// Internal Imports
import { get, post } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

// Destructuring
const { APIS } = API_ENDPOINTS;

/*
==========================================
        Quotes Functions
==========================================
*/

const generateDocumentID = type =>
  new Promise((resolve, reject) => {
    post(`${APIS.GET_DOCTYPE_ID}/${type}`)
      .then(res => {
        resolve(res.document_id);
      })
      .catch(err => {
        reject(err);
      });
  });
/*
==========================================
            Quoteterm Functions
==========================================]
*/

const fetchQuotetermTemplateByID = id =>
  new Promise((resolve, reject) => {
    get(`${APIS.QUOTETERM_TEMPLATES}/${id}`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export { fetchQuotetermTemplateByID, generateDocumentID };
